import React, { useState } from 'react';
import { Collapse, Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import MinusIcon from 'mdi-react/MinusIcon';
import PlusIcon from 'mdi-react/PlusIcon';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileInvoiceDollar, faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import IconButton from '@material-ui/core/IconButton';
import AlertModal from '../../../shared/components/Modal';
import Tooltip from '@material-ui/core/Tooltip';
import { useHistory } from "react-router-dom";
import ListFees from './ListFees';
import ModalPaymentType from './ModalPaymentType';
import ListFeesActions from './ListFeesActions';
import Spinner from 'react-bootstrap/Spinner';

const ProfesionalCollapse = ({ profesional, className,thirds }) => {

  const profesionalMedical = profesional;

  const history = useHistory();

  const [fees, setFees] = useState([]);
  const [collapse, setCollapse] = useState(false);
  const [view, setView] = useState({ styleClass: 'closed', icon: <PlusIcon /> });
  const [isLoading, setIsLoading] = useState(false);
  const [modalPaymentTypeOpen, setModalPaymentTypeOpen] = useState(false);

  //Alerta
  const [showAlertModal, setAlerShowModal] = React.useState(false);
  const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
  const [colorAlertModal, setAlertColorModal] = React.useState("success");


  const alertModal = (success, message) => {
    if (success == true) {
      setAlertColorModal("success");
    }
    else {
      setAlertColorModal("danger");
    }
    setAlerShowModal(true);
    setAlertMessageModal(message);
  }

  const onEntering = () => {
    setView({ styleClass: 'opening', icon: <MinusIcon /> });
  };

  const onEntered = () => {
    setView({ styleClass: 'opened', icon: <MinusIcon /> });
  };

  const onExiting = () => {
    setView({ styleClass: 'closing', icon: <PlusIcon /> });
  };

  const onExited = () => {
    setView({ styleClass: 'closed', icon: <PlusIcon /> });
  };

  const toggle = () => {
    setCollapse(prevState => !prevState);
  };

  const editPaymentType = () => {
    setCollapse(prevState => !prevState);
    setModalPaymentTypeOpen(true);
  }

  const updateFee = (id_servicio, tipo, valor) => {
    setIsLoading(true);
    setTimeout(() => {
      let arrFee = fees.slice();
      let pos = arrFee.findIndex(element => element.id_servicio == id_servicio);
      arrFee[pos].tipo = tipo;
      arrFee[pos].valor = valor;

      if (tipo == 1) {
        arrFee[pos].valor_string = valor.toString() + "%";
      }
      else {
        arrFee[pos].valor_string = valor.toString();
      }
      setFees(arrFee);
      setIsLoading(false);
    }, 200);
  }

  const FeesProfesional = () => {
    return (
      <ListFees
        reactTableData={fees}
        ReactTableActions={ListFeesActions}
        profesional={profesional}
        updateFee={updateFee}
        thirds={thirds}
      />
    )
  }

  const updatePaymentType = (paymentType) => {
    profesionalMedical.tipo_pago = paymentType;
  }

  React.useEffect(() => {
    setFees(profesional.honorarios);
  }, []);

  return (
    <div className={`collapse__wrapper_visit ${view.styleClass} ${className}`} dir="ltr">
      <button onClick={toggle} className="collapse__title" type="button">
        {view.icon}

        <Row>
          <Col md={6}>
            <p className="text-dark">
              <b className="h6">
                {
                  profesional.apellido2 != null ? profesional.nombres + " " + profesional.apellido1 + " " + profesional.apellido2 :
                    profesional.nombres + " " + profesional.apellido1
                }
                &nbsp;&nbsp;&nbsp;
              </b>

              <Tooltip title="Cambiar Tipo de Pago">
                <IconButton
                  onClick={editPaymentType} className="text-success"
                >
                  <FontAwesomeIcon icon={faFileInvoiceDollar} />
                </IconButton>
              </Tooltip>
            </p>
          </Col>
          <Col md={4}>
            <label>
              <b>
                Tipo de Pago:
              </b>
              {
                profesional.tipo_pago == 1 ? 'Por Servicios' : 'Por Valor Fijo'
              }
            </label>
          </Col>
          <Col md={2}>
            <p>
              {collapse == false ? <FontAwesomeIcon icon={faPlus} className="text-dark" />
                :
                <FontAwesomeIcon icon={faMinus} className="text-dark" style={{ color: '#71BFDF' }} />
              }
            </p>
          </Col>
        </Row>

      </button>
      <Collapse
        isOpen={collapse}
        className="collapse__content"
        onEntering={onEntering}
        onEntered={onEntered}
        onExiting={onExiting}
        onExited={onExited}
      >
        <div className="text-center" style={{ fontSize: '14px' }}>
          {
            !isLoading ? <FeesProfesional /> : <Spinner animation="border" variant="success" />
          }


        </div>
      </Collapse>

      <ModalPaymentType
        opened={modalPaymentTypeOpen}
        doCloseModalPaymentType={() => setModalPaymentTypeOpen(false)}
        profesional={profesionalMedical}
        updatePaymentType={updatePaymentType}
      />


      <AlertModal
        color={colorAlertModal}
        title={messagAlerteModal}
        modal={showAlertModal}
        onOk={() => setAlerShowModal(true)}
        toggle={() => {
          setAlerShowModal(false);
        }
        }
      />
    </div>
  );
};

ProfesionalCollapse.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.element.isRequired,
};

ProfesionalCollapse.defaultProps = {
  title: '',
  className: '',
};

export default ProfesionalCollapse;
